import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective } from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';

import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-availability-map-split-landing',
  templateUrl: './coverage-map.component.html',
  styleUrl: './coverage-map.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, StarRatingModule, MatIcon],
})
export class CoverageMapSectionComponent extends BaseSectionComponent {}
